/* eslint-disable */
import './App.css';
import { useState } from 'react';


function App() {
  let post = '강남 우동 맛집';
  let style= { color: 'red', fontSizetS: '16px' }
  let [글제목, 글제목변경] = useState(['남자코트 추천', '강남맛집 추천', '코딩강의 추천']);
  let [modal, setModal] = useState(false);//처음에 안보이는 설정
  let [따봉, 따봉변경] = useState([0, 0, 0]);
  let [title, setTitle] = useState(0);
  let [입력값, 입력값변경] = useState('');

  function eventhendleSetModal() {
      if (modal === false) {
        return setModal(true)
      } else {
        return setModal(false);
      }
    }
  
  function eventhendleChangeTitle() {
    let copy = [...글제목];
    copy[0] = '여자 코트 추천';
    글제목변경(copy);
  }
  /* useState를 사용하는 이유 변수가 바뀔때마다 코드를 다시 적어주지 않고
  useState에 값을 저장하고 상태가 변화할때마다 Htmle이 자동으로 재렌더링이 되게 할 수 있기때문에 사용함 
   */

  function eventhendleAddButton() {
    let copy = [...글제목];
    if (입력값 !== "" && !글제목.includes(입력값)) {
    copy.unshift(입력값);
    글제목변경(copy)
    }

    let copy1 = [...따봉];
    따봉변경(copy1.concat(0))
  }


  /*UseState 사용방법 (Destructuring)
  UseState는 []를 만들기때문에 이렇게 사용 가능
  let num = [1, 2];
  let [a, c] = [1, 2];
  */
  return (
    <div className="App">
      <div className='black-nav'>
        <h4>ReactBlog</h4>
      </div>

      {/* 배열은 저장되는 공간이 따로 있으며 배열의 내용을 수정하기 위해서는 배열으 값을 새로운 배열로 복사해와야 저장되어 있는 공간에서 새로운 주소값을 부여함 그렇지 않으면 원본 배열이  수정이 되며 useState에서 변경된 값을 불러올때 동일한 배열이면 변경하지 않음. 그래서 새로운 배열을 만들어서 불러와야 함 */}

      <button onClick={ ()=> {
        let copy = [...글제목];
        copy.sort();
        글제목변경(copy);
      }}> 정렬버튼</button>
      <button onClick={eventhendleChangeTitle}>글 수정</button>
      {/* <div className='list'>
        <h4>{ 글제목[0] } <span onClick={ ()=> {따봉변경(따봉 + 1)} }>👍</span> { 따봉 } </h4>
        <p>2월 17일 발행</p>
      </div>

      <div className='list'>
        <h4 onClick={ ()=> { setModal(!modal)} }>{ 글제목[2] }</h4>
        <p>2월 17일 발행</p>
      </div> */}
        {
          글제목.map((el, i) => {
            return(       
              <div className='list' key={i}>
              <h4 onClick={()=> { setModal(!modal); setTitle(i) }}> { 글제목[i] }
               <span onClick={(e)=>{ e.stopPropagation();
                let copy = [...따봉];
                copy[i] = copy[i] + 1;
                따봉변경(copy)
               }}>👍</span> {따봉[i]}
              </h4>
              <p>4월 15일 발행</p>
              <button onClick={() => {
                let copy = [...글제목]
                copy.splice(i, 1)
                글제목변경(copy)
              }}>글삭제</button>
              </div>
          )
        })
        }
        <input onChange={(e) => {
          입력값변경(e.target.value)}}
          ></input>
          <button onClick={eventhendleAddButton}>글 등록</button>

        {
          modal === true ? <Modal title={title} eventhendleChangeTitle={eventhendleChangeTitle} 글제목={글제목}/> : ''
        //삼항연산자: 조건식 ? 참일때 실행할 코드: 거짓일 때 실행할 코드
        }   
     </div>
  );
}
  /*[동적인 UI만드는 step]
  1.html css로 미리 디자인 완성
  2.UI의 현재 상태를 state로 저장
  3.state에 따라 UI가 어떻게 보일지 작성(조건문)
  */

  /* 반복적으로 출현하는 html은 컴포넌트화 하기
    큰 페이지들은 컴포넌트로 만들 수 있음 
  */


  /* props 문법
  부모에게 있던 state를 자녀가 가져쓰려면 props문법을 써야함
  자식 컴포넌트를 쓰는곳에 작명={state이름}한후 자식 컴포넌트 파라미터에 props를 넣고
  자식 컴포넌트안 사용하고싶은곳에서 props.작명으로 하면 사용할 수 있음 

  */
function Modal(props) {
  return(
    <div className='modal'>
      <h4>{ props.글제목[props.title] }</h4>
      <p>날짜</p>
      <p>상세내용</p>
      <button>글수정</button>
    </div>
  )
}

export default App;
